export default __webpack_public_path__ + "static/media/EmergencyItemsOrangeIcon.a3034be3.png";